import React, {
  useRef,
  useEffect,
  useState,
  useLayoutEffect,
  useMemo
} from 'react';
import CommunityContactUsHeadless from '../../../modules/community-contact-us-headless';
import useEventBus, { dispatch } from '../../../hooks/useEventBus';
import { buildEngine } from '../../../coveo/engine/Engine';
import {
  getCoveoFindACommunityFieldsToInclude,
  getLocationCookie,
  sendCoveoGeolocationQuery
} from '../../helpers';
import { buildResultList } from '@coveo/headless';

const CommunityContactUs = ({
  locationCookieName,
  coveoOrganizationId,
  coveoAccessToken,
  coveoSearchHub,
  coveoPipeline,
  module,
  coveoSource = 'Production US - English',
  coveoContextLanguage = 'en',
  coveoSearchRadiusInMiles = 50
}) => {
  const [waitingForGeolocation, setWaitingForGeolocation] = useState(false);
  const [geolocationData, setGeolocationData] = useState(null);
  const [moduleInstance, setModuleInstance] = useState(null);
  const [lastZip, setLastZip] = useState(null);
  const [results, setResults] = useState(null);
  const firstSearch = useRef(true);

  const elementRef = useRef(null);
  const zipElementRef = useRef(null);
  const listenerRef = useRef(null);

  const engine = useMemo(() => {
    return buildEngine({
      organizationId: coveoOrganizationId,
      accessToken: coveoAccessToken,
      searchHub: coveoSearchHub,
      pipeline: coveoPipeline
    });
  }, []);

  const resultsListController = useMemo(
    () =>
      buildResultList(engine, {
        options: {
          fieldsToInclude: getCoveoFindACommunityFieldsToInclude()
        }
      }),
    []
  );

  const sendQuery = () => {
    let cookieData = getLocationCookie(locationCookieName);
    if (cookieData) {
      sendCoveoGeolocationQuery({
        engine: engine,
        latitude: cookieData.Latitude,
        longitude: cookieData.Longitude,
        source: coveoSource,
        radiusInMiles: parseFloat(coveoSearchRadiusInMiles),
        state: cookieData.State,
        language: coveoContextLanguage,
        pipeline: coveoPipeline
      });
    }
    setWaitingForGeolocation(false);
  };

  useEventBus(
    'geolocation-received',
    ({ payload }) => {
      if (payload.error) {
        moduleInstance.showZipError();
        return;
      }
      if (waitingForGeolocation && !payload.sameSearchValue) {
        if (payload.Module === module) {
          sendQuery();
        }
      }
    },
    [waitingForGeolocation, moduleInstance]
  );

  const GetZipResults = e => {
    const zip = e.target.value;
    if (zip === lastZip) return;
    setLastZip(zip);
    dispatch({
      type: 'get-zip-geolocation',
      payload: {
        value: zip,
        country: null,
        firstSearch: firstSearch.current,
        moduleName: module
      }
    });
    firstSearch.current = false;
    setWaitingForGeolocation(true);
  };

  useEffect(() => {
    if (moduleInstance && results) {
      moduleInstance.setResults(results);
    }
  }, [results]);

  useEffect(() => {
    resultsListController.subscribe(() => {
      // if (resultsListController.state.results.length !== 0 && moduleInstance) {
      //   moduleInstance.removeInputError();
      // }
      setResults(resultsListController.state.results);
    });
  }, [moduleInstance]);

  useLayoutEffect(() => {
    const sectionElement = elementRef.current.closest(
      '.community-contact-us-headless'
    );
    if (sectionElement) {
      zipElementRef.current = sectionElement.querySelector(
        '.community-contact-us__zip input'
      );

      if (zipElementRef && zipElementRef.current) {
        const contactUsFormInstance = new CommunityContactUsHeadless(
          sectionElement
        );
        setModuleInstance(contactUsFormInstance);
        listenerRef.current = GetZipResults;
        zipElementRef.current.addEventListener('blur', listenerRef.current);

        return () => {
          zipElementRef.current.removeEventListener('blur', listenerRef.current);
        };
      }
    }
  }, []);

  return <div ref={elementRef}></div>;
};

export default CommunityContactUs;
